import common from '@page/common/js/common';
import Vue from 'vue';
import PictureFilter from '@global/components/productList_vue/PictureFilter.vue';
import globalLayout from '@global/components/Home/globalLayout'; //公版模組
// import $ from 'jquery';

// import freelayout from '@global/components/Home/freelayout';
// import popup from '@global/components/Home/popup'; //首頁popup

require('@global/vendors/slick');

// const HomeContent = function() {
// 	$(window).scroll()
//     $('.main')
//       .css({'visibility': 'visible'})
//       .addClass('js-loaded')
//     $('.home-loading').fadeOut()
// }

// HomeContent();

// freelayout.initSlick();
// freelayout.transitionEffects();

setTimeout(function () {
  $('#page-home').css('opacity', '1');
}, 100);

// new Fastip('addToCart', {
//   domainName: 'https://www.popdaily.com.tw',
//   brandName: 'test',
//   btnAddToCart: '.btnAddToCartClassName',
// });

const app = new Vue({
  el: '#index-content',
  components: { PictureFilter },
  mounted() {
    this.$nextTick(() => {
      globalLayout({
        banner: {
          isopen: true,
          opts: {
            dots: true,
            arrows: false,
            speed: 800,
            autoplay: true,
            autoplaySpeed: 5000,
          },
          squareOpts: {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false,
            arrows: true,
            speed: 800,
            responsive: [
              {
                breakpoint: 415,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  centerMode: true,
                  dots: false,
                },
              },
            ],
          },
          fullbanner: {
            play: 5000,
          },
        },
        popupOpen: true,
      });
    });
  },
});

// $('.square-slide').each(function() {
//     $(this).not('.slick-initialized').slick({
//         infinite: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true,
//         arrows: false,
//         speed: 800,
//         responsive: [
//         {
//             breakpoint: 415,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 arrows: false,
//                 centerMode: true,
//                 dots: false
//             }
//         },
//         ]
//     });
// });
